export default {
  'mode': {
    'timeline': 'タイムライン',
    'gps': 'GPS',
    'pole-id': 'ポールID',
  },
}
